import { LogoutIcon } from "../../../assets"
import styles from "./style.module.css"

export const LogoutButton = () =>{

    const handleClick = () => {
        // window.open("https://www.example.com", "_blank"); // Replace with the desired URL
        console.log("Clicked");
      };

    return(

        <div className={styles.container} onClick={handleClick}>
            <LogoutIcon className={styles.icon}/>
            Logout
        </div>

    )

}